// Shared friendship types definition
export const FRIENDSHIP_TYPES = {
  'acquaintance': {
    name: 'Acquaintance or Casual',
    icon: '👋',
    description: 'People you know by name and interact with occasionally (coworkers, neighbors, classmates).'
  },
  'activity-based': {
    name: 'Activity-Based',
    icon: '🏃‍♀️',
    description: 'Centered on a shared hobby or context—like a gym buddy or gaming partner.'
  },
  'situational': {
    name: 'Situational or Circumstantial',
    icon: '🏠',
    description: 'Formed because you are in the same life stage or environment (college roommate, new-parent group).'
  },
  'close': {
    name: 'Close or Best Friend',
    icon: '💕',
    description: 'Deep mutual affection, trust, and consistent emotional support.'
  },
  'lifelong': {
    name: 'Lifelong or Kindred Spirit',
    icon: '🌟',
    description: 'Relationships that persist across decades and life changes.'
  },
  'mentor-mentee': {
    name: 'Mentor–Mentee',
    icon: '🎓',
    description: 'A friendship where one person is significantly more experienced or older.'
  },
  'workplace': {
    name: 'Workplace or Professional',
    icon: '💼',
    description: 'Colleagues with whom you share camaraderie beyond formal duties.'
  },
  'chosen-family': {
    name: 'Chosen Family',
    icon: '👨‍👩‍👧‍👦',
    description: 'Friends who fill roles similar to family—especially when biological family is absent or distant.'
  },
  'digital-first': {
    name: 'Digital-First or Online',
    icon: '💻',
    description: 'Bonds formed primarily through digital spaces (gaming communities, social media, forums).'
  }
};

// Utility function to get relationship icon
export const getRelationshipIcon = (relationship) => {
  return FRIENDSHIP_TYPES[relationship]?.icon || '👫';
};

// Utility function to get friendship type name
export const getFriendshipTypeName = (relationship) => {
  return FRIENDSHIP_TYPES[relationship]?.name || 'Friend';
};

